import { Components } from '@formio/js';
import { ApplicationRef, ComponentRef, createComponent, Injector } from '@angular/core';
import { DatePickerComponent } from './date-picker.component';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { environmentInjector } from '../../../shared/formio-environment';
import { CustomDateAdapter } from '../../../shared/custom-date-adapter';

const Field = (Components as any).components.field;

export class DatePickerFormioComponent extends Field {
    constructor(...args: any[]) {
        super(...args);
    }

    static schema(...extend) {
        return Field.schema({
            type: 'datePicker',
            label: 'Data',
            key: 'datePicker',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Data',
            selector: 'date-picker',
            icon: 'fa fa-calendar',
            group: 'advanced',
            weight: 51,
            schema: DatePickerFormioComponent.schema(),
        };
    }

    angularRef?: ComponentRef<DatePickerComponent>;

    render(children) {
        return super.render(`<div class="formio-angular-host"></div>`);
    }

    attach(element) {
        const result = super.attach(element);

        const host = element.querySelector('.formio-angular-host');
        if (!host) return result;

        if (!environmentInjector) {
            console.warn('No EnvironmentInjector found');
            return result;
        }

        this.angularRef = createComponent(DatePickerComponent, {
            environmentInjector: environmentInjector,
            hostElement: host,
            elementInjector: Injector.create({
                providers: [
                    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
                    { provide: NgxMatDateAdapter, useClass: CustomDateAdapter },
                ],
                parent: environmentInjector,
            }),
        });

        Object.assign(this.angularRef.instance, {
            disabled: this.disabled,
            value: this.dataValue
        });

        this.angularRef.instance._value = this.dataValue;
        this.angularRef.instance._valueChange.subscribe((val) => this.setValue(val, {}));

        const appRef = environmentInjector.get(ApplicationRef);
        appRef.attachView(this.angularRef.hostView);

        this.on('destroy', () => {
            appRef.detachView(this.angularRef.hostView);
            this.angularRef.destroy();
        });

        return result;
    }

    setValue(value, flags) {
        super.setValue(value, flags);
        if (this.angularRef?.instance && this.angularRef.instance._value !== value) {
            this.angularRef.instance._value = value;
        }
    }

    detach() {
        if (this.angularRef) {
            this.angularRef.destroy();
            this.angularRef = undefined;

            if (this.appRef) {
                this.appRef.detachView(this.angularRef.hostView);
                this.appRef = undefined;
            }
        }
        super.detach();
    }
}

Components.addComponent('datePicker', DatePickerFormioComponent);
